import { FC } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Select,
} from "@chakra-ui/react";

export const CustomSelect: FC<any> = (props) => {
  const {
    input,
    name,
    label,
    meta,
    placeholder,
    options,
    onChangeVehicleId,
    ...rest
  } = props;
  return (
    <FormControl isInvalid={meta.error && meta.touched}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Select
        {...input}
        {...rest}
        onChange={(arg) => {
          if (input?.onChange) {
            input.onChange(arg);
          }
          if (typeof onChangeVehicleId === "function") {
            onChangeVehicleId(arg.target.value);
          }
        }}
        isInvalid={meta.error && meta.touched}
        id={name}
        placeholder="Не выбрано"
      >
        {options.map((option) => (
          <option value={option.id} key={option.id}>
            {option.label || option.name || option.title}
          </option>
        ))}
      </Select>
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};
